import { Options } from 'react-use-websocket';
import { IConfigs } from '@interfaces/profile';
import { ILogoutForced, IUser } from '@interfaces/user';
import React from 'react';
import { IEventStyle } from '@interfaces';
import { IWorldSettings } from '@interfaces/worlds';
import { IWebSocketConnectionInfo } from '@interfaces/webSocketConnectionInfo';
import { IUserAvatar } from '@interfaces/avatar';
import { NOTIFICATION_TYPES } from '@components/Notification';
import { AnalyticsType } from '@interfaces/analytics';
import { INewAvaturnData } from '@features/avaturn/interfaces';
import ParticipantScopes from '@constants/scopes';

export type GetWebSocketUrlType = () => Promise<string>;
export type GetWebSocketOptionsType = (params: {
  withReconnection: boolean;
  filter?: (message: any) => boolean;
  disableJson?: boolean;
}) => Options;

export enum CurrentScreenEnum {
  DEFAULT = 'default',
  LOGIN = 'login',
  AVATAR_SELECTION = 'avatarSelection',
  AVATURN = 'avaturn',
  DEVICES_TEST_MICROPHONE = 'devicesTestMicrophone',
  DEVICES_TEST_SPEAKER = 'devicesTestSpeaker',
  DEVICES_TEST_CONNECTION = 'devicesTestConnection',
  DEVICES_TEST_WEBCAM = 'devicesTestWebcam',
  LOADING_STREAM = 'loadingStream',
  LOADING_UE = 'loadingUE',
  WORLD = 'world',
}

export interface IMytaverseContext {
  token: string;
  idToken: string;
  configs: IConfigs | null;
  userId?: string | null;
  user: IUser;
  userPermissions: ParticipantScopes[];
  isLogoutForced: false | ILogoutForced;
  setUser: React.Dispatch<IUser | any>;
  setUserPermissions: React.Dispatch<React.SetStateAction<ParticipantScopes[]>>;
  signIn: () => void;
  logoutUser: () => void;
  changeUserProfile: (username: any) => void;
  loading: boolean;
  setIsAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
  changingUserData: boolean;
  selectedLanguage: string;
  selectLanguage: (language: string) => void;
  appTheme: IEventStyle;
  appSettings: IWorldSettings | null;
  websocketConnectionInfo?: IWebSocketConnectionInfo;
  loginError: string | null;
  setLoginError: (error: string) => void;

  setWebsocketConnectionInfo: (
    websocketConnectionInfo: IWebSocketConnectionInfo,
  ) => void;
  getWebsocketUrl: GetWebSocketUrlType;
  getWebSocketOptions: GetWebSocketOptionsType;
  websocketSessionId: string;

  setCurrentAvatarId: React.Dispatch<React.SetStateAction<string | null>>;
  currentAvatarId: string | null;
  setCustomAvatarUrl: React.Dispatch<React.SetStateAction<string | null>>;
  customAvatarUrl: string | null;
  setUserAvatars: React.Dispatch<React.SetStateAction<IUserAvatar[] | []>>;
  userAvatars: IUserAvatar[];
  unfinishedAvatar: { avatarId: string; avaturnId: string } | null;
  setUnfinishedAvatar: React.Dispatch<
    React.SetStateAction<{ avatarId: string; avaturnId: string } | null>
  >;

  setLoading: React.Dispatch<React.SetStateAction<boolean>>;

  sendMessageToUnreal: (message: any) => void;
  sendMessageToEvent: (eventId: string, message: any) => void;
  sendMessageToRoom: (
    roomId: string,
    participantId: string,
    eventId: string,
    text: string,
  ) => void;
  sendMessageToParticipant: (participantId: string, message: any) => void;
  sendJSONMessageToWebSocket: (message: any) => void;
  isDebugMode: boolean;
  setIsDebugMode: React.Dispatch<React.SetStateAction<boolean>>;
  navigateToEventsPage: (props: {
    message?: string;
    type?: NOTIFICATION_TYPES;
    translateMessage?: boolean;
    isModal?: boolean;
  }) => void;

  trackAnalytics: (type: AnalyticsType, payload?: any) => Promise<void>;
  isLogoutClicked: () => boolean;
  currentScreen: CurrentScreenEnum;
  setCurrentScreen: React.Dispatch<React.SetStateAction<CurrentScreenEnum>>;
  wantsToCreateAvatar: boolean;
  setWantsToCreateAvatar: React.Dispatch<React.SetStateAction<boolean>>;
  isCreatingGenericAvaturn: boolean;
  setIsCreatingGenericAvaturn: React.Dispatch<React.SetStateAction<boolean>>;
  avaturnToProcess: INewAvaturnData | null;
  setAvaturnToProcess: React.Dispatch<
    React.SetStateAction<INewAvaturnData | null>
  >;
  pageClicked: boolean;
  setPageClicked: React.Dispatch<any>;
  skipLinkInHeader: any;
  setSkipLinkInHeader: React.Dispatch<any>;
  setShowFeedbackForm: React.Dispatch<React.SetStateAction<boolean>>;
  showFeedbackForm: boolean;
}
